import { useMemo } from 'react';
import { searchParamKeys } from '../../../../shared/configs/searchParams';
import {
  useSearchParamsMethods,
  useSearchParamsSelector,
} from '../../../../shared/packages/searchParamsManager';
import { toInteger } from '../../../../shared/packages/searchParamsNormalizer';

const keySearch = searchParamKeys.roomsTablePageSize;
const keyLocal = 'roomsTablePageSize';

export const usePageSizeConfig = () => {
  const { setParams } = useSearchParamsMethods();

  const pageSizeAcceptanceParams = useSearchParamsSelector((state) =>
    toInteger(state[keySearch])
  );

  const pageSizeAcceptanceLocal = JSON.parse(localStorage.getItem(keyLocal));

  const value = useMemo(
    () => pageSizeAcceptanceParams ?? pageSizeAcceptanceLocal ?? 10,
    [pageSizeAcceptanceLocal, pageSizeAcceptanceParams]
  );

  const onChange = (value) => {
    setParams({ [keySearch]: value });
    localStorage.setItem(keyLocal, JSON.stringify(value));
  };

  return { value, onChange };
};
